// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'object-case-solid';

export const Component = () => (
  <g fill='currentColor' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='none' d='M7 14H4m11.188-7.812 1.126-.001c.74 0 1.277.702 1.086 1.416' />
    <path d='M15.188 6.188v-1.25c0-.622-.504-1.126-1.126-1.125H8.189V2.688c0-.622-.504-1.126-1.126-1.125H3.688c-.62 0-1.124.504-1.124 1.125v10.1c.025 1.466 2.1 1.738 2.501.328l1.764-6.115c.139-.482.58-.814 1.081-.814l7.297.022' />
    <path d='m17.1 12.76-3.04-3.04a.642.642 0 0 0-.44-.2H8.94l2.6 3.2c.12.12.12.32 0 .44l-2.6 3.2h4.68c.16 0 .32-.08.44-.2l3.04-3.04c.12-.04.12-.2 0-.36z' />
  </g>
);

export const viewBox = '0 0 18 18';
